// components/Footer.jsx
import React from "react";
import { Box, Container, Stack, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

/**
 * Footer with logo, copyright, quick links,
 * and developer credit.
 */
export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        mt: "auto",
        borderTop: "1px solid",
        borderColor: "divider",
        py: { xs: 4, md: 5 },
        backgroundImage:
          "linear-gradient(180deg, rgba(0,12,32,0) 0%, rgba(0,12,32,0.5) 100%)",
      }}
    >
      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "center", sm: "center" }}
          justifyContent="space-between"
        >
          {/* Left: Logo + copyright + dev credit */}
          <Stack spacing={0.5} alignItems={{ xs: "center", sm: "flex-start" }}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box
                component="img"
                src="/logo.png"
                alt="ARL Logo"
                sx={{ height: 32 }}
              />
              <Typography variant="body2" color="text.secondary">
                © {new Date().getFullYear()} ARL – Abomination Racing League
              </Typography>
            </Stack>

            <Typography variant="caption" color="text.secondary">
              Developed by{" "}
              <Link
                href="https://www.quantummindsoftware.com"
                target="_blank"
                rel="noreferrer"
                underline="hover"
                color="inherit"
              >
                QuantumMind Software
              </Link>
            </Typography>
          </Stack>

          {/* Right: links */}
          <Stack direction="row" spacing={2} flexWrap="wrap" justifyContent="center" useFlexGap>
            <Link
              component={RouterLink}
              to="/rules"
              color="inherit"
              underline="hover"
            >
              Rules
            </Link>

            <Link
              component={RouterLink}
              to="/privacy"
              color="inherit"
              underline="hover"
            >
              Privacy
            </Link>

            <Link
              component={RouterLink}
              to="/terms"
              color="inherit"
              underline="hover"
            >
              Terms
            </Link>

            <Link
              href="/join"
              target="_blank"
              rel="noreferrer"
              color="inherit"
              underline="hover"
            >
              Discord
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
